"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetEventQueue = exports.queueEventNameCount = exports.queueContainsEventType = exports.debugEventQueue = exports.emitEvent = exports.addSink = exports.addMiddleware = void 0;
var consts_1 = require("./consts");
var emitters_1 = require("./emitters");
Object.defineProperty(exports, "emitEvent", { enumerable: true, get: function () { return emitters_1.emitEvent; } });
var events_1 = require("./events");
Object.defineProperty(exports, "resetEventQueue", { enumerable: true, get: function () { return events_1.resetEventQueue; } });
Object.defineProperty(exports, "debugEventQueue", { enumerable: true, get: function () { return events_1.debugEventQueue; } });
Object.defineProperty(exports, "queueContainsEventType", { enumerable: true, get: function () { return events_1.queueContainsEventType; } });
Object.defineProperty(exports, "queueEventNameCount", { enumerable: true, get: function () { return events_1.queueEventNameCount; } });
var middlewares_1 = require("./middlewares");
Object.defineProperty(exports, "addMiddleware", { enumerable: true, get: function () { return middlewares_1.addMiddleware; } });
var sinks_1 = require("./sinks");
Object.defineProperty(exports, "addSink", { enumerable: true, get: function () { return sinks_1.addSink; } });
if (typeof window !== 'undefined') {
    var exported = {
        addMiddleware: middlewares_1.addMiddleware,
        addSink: sinks_1.addSink,
        debugEventQueue: events_1.debugEventQueue,
        emitEvent: emitters_1.emitEvent,
        queueContainsEventType: events_1.queueContainsEventType,
        queueEventNameCount: events_1.queueEventNameCount,
        resetEventQueue: events_1.resetEventQueue,
    };
    var loadedEvent = new CustomEvent(consts_1.InitEventType, { detail: exported });
    window.dispatchEvent(loadedEvent);
}
